import {
  type PowerLabData,
  type PowerRegionData,
} from "../powerBubbleChartData"

// Bars are sized against the single largest compute number on screen (a region
// stock or a lab), so every bar in the tooltip is read off one shared ruler.
export const getLargestComputeShown = (regions: PowerRegionData[]): number => {
  const everyValue = regions.flatMap(region => [
    region.computeStock,
    ...region.labs.map(lab => lab.compute),
  ])
  const positive = everyValue.filter(value => value > 0)
  return positive.length ? Math.max(...positive) : 0
}

// A region lists its frontier labs biggest first, then its non-frontier
// (borderOnly) cells biggest first — individual border-only labs plus the
// residual "Rest of X" tail — so the nested rows read as a ranked breakdown.
export const getLabsWorthShowing = (
  region: PowerRegionData
): PowerLabData[] => {
  const labsWithCompute = region.labs.filter(lab => lab.compute > 0)
  const frontierLabs = labsWithCompute.filter(lab => !lab.borderOnly)
  const nonFrontierLabs = labsWithCompute.filter(lab => lab.borderOnly)
  return [
    ...frontierLabs.sort((a, b) => b.compute - a.compute),
    ...nonFrontierLabs.sort((a, b) => b.compute - a.compute),
  ]
}
